import React from 'react';

import { ListItem, ListItemIcon, Checkbox, Chip, Typography, Grid } from '@material-ui/core';

import { AssetItem, RecommendedAsset } from 'config/api/actionLibrary/actionLibrary.types';

import { useImportanceHelpers } from '../utils/importanceHelpers';

interface AssetListItemProps {
  asset: RecommendedAsset | AssetItem;
  isSelected: boolean;
  onToggle: () => void;
  isRecommended?: boolean;
}

const AssetListItem: React.FC<AssetListItemProps> = ({ asset, isSelected, onToggle, isRecommended = false }) => {
  const { getLabel, getColor } = useImportanceHelpers();

  const isRecommendedAsset = isRecommended && 'owner' in asset && 'profile' in (asset as RecommendedAsset).owner;
  const recommendedAsset = isRecommendedAsset ? (asset as RecommendedAsset) : null;
  const regularAsset = !isRecommendedAsset ? (asset as AssetItem) : null;

  const ownerFullName = recommendedAsset
    ? `${recommendedAsset.owner.profile.firstName} ${recommendedAsset.owner.profile.lastName}`.trim()
    : regularAsset?.owner.fullName || '';

  const categoryName = recommendedAsset?.category?.name ?? regularAsset?.category?.name ?? '';
  const assetType = recommendedAsset?.type || regularAsset?.type || categoryName;

  const importance = recommendedAsset?.importance ?? regularAsset?.importance ?? null;
  const importanceChip = importance != null && importance !== '' && (recommendedAsset != null || regularAsset != null) && (
    <Chip
      label={getLabel(importance)}
      size='small'
      style={{
        backgroundColor: getColor(importance),
        color: '#fff',
        flexShrink: 0,
      }}
    />
  );

  return (
    <ListItem alignItems='flex-start' button onClick={onToggle}>
      <ListItemIcon>
        <Checkbox checked={isSelected} color='primary' edge='start' />
      </ListItemIcon>

      <Grid alignItems='center' container spacing={2}>
        <Grid item xs>
          <Typography component='div' variant='subtitle2'>
            {asset.name}
          </Typography>
          <Typography color='textSecondary' component='div' variant='body2'>
            {ownerFullName}
          </Typography>
          <Typography color='textSecondary' component='div' variant='body2'>
            {assetType}
          </Typography>
        </Grid>
        {importanceChip && <Grid item>{importanceChip}</Grid>}
      </Grid>
    </ListItem>
  );
};

export default AssetListItem;
